import PowerCalendarDaysRange from 'ember-power-calendar/components/power-calendar-range/days';

export default class SchoolDatesDaysRange extends PowerCalendarDaysRange {}
